import { Box, Grid, ListItemText, Stack, Typography } from "@mui/material";
import StyledSnippet from "components/ui/atoms/StyledSnippet";
import dayjs from "dayjs";

const NoteListItem = ({ note }) => {
  return (
    <Grid container spacing={2} sx={{ width: "100%" }}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Stack spacing={2} direction="row" justifyContent="space-between">
          <ListItemText
            primary={note.subject}
            secondary={note.owner_full_name_facet}
          />
          <Typography variant="body2">
            {dayjs(note.created_at * 1000).format("DD/MM/YYYY")}
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Box overflow="hidden" height={100}>
          <StyledSnippet hit={note} attribute="content_text" />
        </Box>
      </Grid>
    </Grid>
  );
};

export default NoteListItem;
